import { Attachment } from "../../hooks/socket/types";
import { Direction } from "../../utils/Direction";
import { MessageButton } from "../Chat/types";

export interface MessageModel {
  text?: string;
  userType: Direction;
  writingMachine?: boolean;
  attachments?: Attachment[];
  buttons?: MessageButton[];
  groupMultimedia?: Attachment[];
  createdAt: number;
}


export interface InputChatProps {
  handleSendMessage: (message: MessageModel) => void;
  arrowColor?: string;
  isMomentEmailValidate?: boolean;
  isDisabled?: boolean;
}

export enum INPUT_CHAT_TRANSLATIONS {
PLACEHOLDER = "input_chat_placeholder"
}
